import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { AdminLayout } from '~/components/AdminLayout'
import { CommandPalette } from '~/components/CommandPalette'
import { RequireAdmin } from '~/components/RequireAdmin'
import { useAuthStore } from '~/stores/auth-store'
import { AgentSettingsPage } from '~/pages/AgentSettingsPage'
import { AssessmentDetailPage } from '~/pages/AssessmentDetailPage'
import { AuditPage } from '~/pages/AuditPage'
import { DashboardDetailPage } from '~/pages/DashboardDetailPage'
import { CatalogPage } from '~/pages/CatalogPage'
import { ConversationsPage } from '~/pages/ConversationsPage'
import { DashboardPage } from '~/pages/DashboardPage'
import { KnowledgePage } from '~/pages/KnowledgePage'
import { LoginPage } from '~/pages/LoginPage'
import { ModelsPage } from '~/pages/ModelsPage'
import { NotificationSettingsPage } from '~/pages/NotificationSettingsPage'
import { PromptsPage } from '~/pages/PromptsPage'
import { SessionDetailPage } from '~/pages/SessionDetailPage'
import { UploadsPage } from '~/pages/UploadsPage'
import { UseCaseCatalogPage } from '~/pages/UseCaseCatalogPage'
import { UsersPage } from '~/pages/UsersPage'
import { CertificationPage } from '~/pages/services/CertificationPage'
import { ConsultationPage } from '~/pages/services/ConsultationPage'
import { MaintenancePage } from '~/pages/services/MaintenancePage'
import { MonitoringPage } from '~/pages/services/MonitoringPage'

// 서비스 우선(per-service) IA: 운영 대시보드 + 서비스/거버넌스/콘텐츠/플랫폼 그룹.
export function App() {
    // 앱 로드 시 한 번 세션을 확인한다(/api/auth/me). RequireAdmin/LoginPage는 status를 읽는다.
    const checkSession = useAuthStore((s) => s.checkSession)
    useEffect(() => {
        void checkSession()
    }, [checkSession])

    return (
        <>
            {/* ⌘K 커맨드 팔레트 — 라우터 컨텍스트 안에서 전역 마운트(단축키 자체 처리). */}
            <CommandPalette />
            <Routes>
                <Route path='/login' element={<LoginPage />} />
                <Route
                    element={
                        <RequireAdmin>
                            <AdminLayout />
                        </RequireAdmin>
                    }>
                    <Route index element={<DashboardPage />} />

                    {/* 서비스 */}
                    <Route path='consultation' element={<ConsultationPage />} />
                    <Route
                        path='certification'
                        element={<CertificationPage />}
                    />
                    <Route path='maintenance' element={<MaintenancePage />} />
                    <Route path='monitoring' element={<MonitoringPage />} />

                    {/* 거버넌스 */}
                    <Route
                        path='governance/catalog'
                        element={<UseCaseCatalogPage />}
                    />
                    <Route path='governance/models' element={<ModelsPage />} />
                    <Route
                        path='governance/prompts'
                        element={<PromptsPage />}
                    />
                    <Route
                        path='governance/agents'
                        element={<AgentSettingsPage />}
                    />

                    {/* 콘텐츠 */}
                    <Route path='content/catalog' element={<CatalogPage />} />
                    <Route
                        path='content/knowledge'
                        element={<KnowledgePage />}
                    />
                    <Route path='content/uploads' element={<UploadsPage />} />

                    {/* 플랫폼 */}
                    <Route path='users' element={<UsersPage />} />
                    <Route
                        path='settings/notifications'
                        element={<NotificationSettingsPage />}
                    />
                    <Route path='audit' element={<AuditPage />} />

                    {/* 기존 진입점 유지(질의응답은 서비스 탭 도입 전까지 직접 라우트로 접근).
                        구 /agents(에이전트 카탈로그)는 /governance/agents 에이전트 설정으로 통합됨. */}
                    <Route
                        path='conversations'
                        element={<ConversationsPage />}
                    />
                    {/* 세션 상세 — 대화로그/재생에서 진입(분석 패널 + 전체 transcript). */}
                    <Route
                        path='sessions/:id'
                        element={<SessionDetailPage />}
                    />
                    {/* 인증평가 상세 — 목록/최근 평가에서 진입(분석 + 항목별 점수 드릴다운). */}
                    <Route
                        path='assessments/:id'
                        element={<AssessmentDetailPage />}
                    />
                    {/* 모니터링 대시보드 상세 — 목록에서 진입(측정값 시계열 + 알림). */}
                    <Route
                        path='dashboards/:id'
                        element={<DashboardDetailPage />}
                    />
                    <Route
                        path='agents'
                        element={<Navigate to='/governance/agents' replace />}
                    />
                </Route>
                <Route path='*' element={<Navigate to='/' replace />} />
            </Routes>
        </>
    )
}
